import { ApplicationRef, Injectable, Optional, OnInit } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { Observable, tap, EMPTY, from, share } from 'rxjs';
import { environment } from '../../environments/environment';
import { SwPush, SwUpdate } from '@angular/service-worker';
import { BehaviorSubject } from 'rxjs';
import { resolve } from 'path';

@Injectable({
  providedIn: 'root',
})
export class MessagingService implements OnInit {
  token$: Observable<any> = EMPTY;
  message$: Observable<any> = EMPTY;
  showRequest = false;

  constructor(
    private messaging: Messaging,
    private appRef: ApplicationRef,
    private swPush: SwPush,
    private updates: SwUpdate
  ) {}

  ngOnInit() {
    console.log('FCM: initialized');
  }

  request(): Promise<void> {
    console.log('FCM: Requesting permission');
    return new Promise((resolve, reject) => {
      Notification.requestPermission()
        .then((permission) => {
          if (permission === 'granted') {
            console.log('FCM: Notification permission granted.');
            // Initialize token generation immediately after permission is granted
            this.getToken(false);
            resolve();
          } else {
            console.log('FCM: Unable to get permission to notify.', permission);
            reject();
          }
        })
        .catch((err) => {
          console.error('FCM: Unable to get permission to notify.', err);
          reject(err);
        });
    });
  }

  getToken(andRequestPermission: boolean = false) {
    console.log('FCM: Getting token with VAPID key:', environment.vapidKey.substring(0, 20) + '...');
    if (this.messaging) {
      this.token$ = from(
        navigator.serviceWorker
          .getRegistration()
          .then((serviceWorkerRegistration) => {
            console.log('FCM: Service worker registration found:', !!serviceWorkerRegistration);
            
            if (!serviceWorkerRegistration) {
              console.log('FCM: No service worker registration, registering firebase-messaging-sw.js');
              return navigator.serviceWorker.register('/firebase-messaging-sw.js', {
                scope: '/firebase-cloud-messaging-push-scope'
              })
                .then((registration) => {
                  console.log('FCM: Firebase service worker registered successfully with scope:', registration.scope);
                  return registration;
                })
                .catch((error) => {
                  console.error('FCM: Failed to register firebase service worker:', error);
                  throw error;
                });
            }
            
            return serviceWorkerRegistration;
          })
          .then((serviceWorkerRegistration) => {
            console.log('FCM: Using service worker registration:', serviceWorkerRegistration.scope);
            return getToken(this.messaging, {
              serviceWorkerRegistration,
              vapidKey: environment.vapidKey,
            });
          })
          .then((token) => {
            console.log('FCM: Token generated successfully:', token ? token.substring(0, 20) + '...' : 'null');
            return token;
          })
          .catch((error) => {
            console.error('FCM: Error in token generation process:', error);
            throw error;
          })
      ).pipe(
        tap((token) => {
          console.log('FCM: Token available in observable:', token ? token.substring(0, 20) + '...' : 'null');
          if (andRequestPermission) {
            this.request();
          }
        }),
        share()
      );
      this.message$ = new Observable((sub) =>
        onMessage(this.messaging, (it) => sub.next(it))
      ).pipe(tap((message) => console.log('FCM: Message received:', message)));
    } else {
      console.error('FCM: Messaging service not available');
    }
  }
}
